module.exports = __webpack_public_path__ + "static/media/empty-card-state.b532bb68.svg";